'use strict';

angular.module('adelementAdminApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('excludedField', {
                parent: 'entity',
                url: '/excludedFields',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'adelementAdminApp.excludedField.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/excludedField/excludedFields.html',
                        controller: 'ExcludedFieldController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('excludedField');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('excludedField.detail', {
                parent: 'entity',
                url: '/excludedField/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'adelementAdminApp.excludedField.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/excludedField/excludedField-detail.html',
                        controller: 'ExcludedFieldDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('excludedField');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ExcludedField', function($stateParams, ExcludedField) {
                        return ExcludedField.get({id : $stateParams.id});
                    }]
                }
            })
            .state('excludedField.new', {
                parent: 'excludedField',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/excludedField/excludedField-dialog.html',
                        controller: 'ExcludedFieldDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    entityName: null,
                                    fieldName: null,
                                    role: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('excludedField', null, { reload: true });
                    }, function() {
                        $state.go('excludedField');
                    })
                }]
            })
            .state('excludedField.edit', {
                parent: 'excludedField',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/excludedField/excludedField-dialog.html',
                        controller: 'ExcludedFieldDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['ExcludedField', function(ExcludedField) {
                                return ExcludedField.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('excludedField', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            })
            .state('excludedField.delete', {
                parent: 'excludedField',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/excludedField/excludedField-delete-dialog.html',
                        controller: 'ExcludedFieldDeleteController',
                        size: 'md',
                        resolve: {
                            entity: ['ExcludedField', function(ExcludedField) {
                                return ExcludedField.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('excludedField', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    });
